<template>
  <modal-layout :is-open="isOpen" @close="closeModal()">
    <div class="Modal_area Modal_wide">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="チュートリアルモーダルを閉じる"
        @click="closeModal()"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <!-- Navigation Arrows -->
        <button
          v-show="currentSlide > 0"
          class="nav-arrow left"
          aria-label="Previous slide"
          @click="prevSlide"
        >
          <span class="arrow">‹</span>
        </button>
        <button
          v-show="currentSlide < 6"
          class="nav-arrow right"
          aria-label="Next slide"
          @click="nextSlide"
        >
          <span class="arrow">›</span>
        </button>
        <div class="slides-container">
          <!-- Slide 1 -->
          <div v-show="currentSlide === 0" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <img src="/assets/img/melon_menulogo_blue_.png" alt="MELON" class="logo">
                <h1 class="title">
                  HOW TO USE
                </h1>
                <h2 class="subtitle">
                  MELONの使い方
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="text">
                    MELONが
                    <br>
                    あなたをマインドフルにするために
                    <br>
                    できることを1分でお伝えします。
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    次へ
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_1.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 2 -->
          <div v-show="currentSlide === 1" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  脳と心を休ませる
                  <br>
                  ２種類のクラスが受け放題
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    リアルタイム受講
                  </p>
                  <p class="text">
                    一定のリズムでルーティーン化したい方や、つながりを
                    <br>
                    より感じたい方はリアルタイム受講がおすすめ！
                    <br>
                    開催クラスはマイページで要チェック！
                  </p>
                  <p class="heading">
                    アーカイブ受講
                  </p>
                  <p class="text">
                    時間にとらわれず好きな時に受けたい方には
                    <br>
                    アーカイブ(MELON TV)での受講がおすすめ！
                    <br>
                    リアルタイムにはない5-10分クラスも用意しています。
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    次へ
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_2.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 3 -->
          <div v-show="currentSlide === 2" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  毎月のストレスチェックで
                  <br>
                  今の自分の状態がわかる
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    MELONユーザーの9割が回答！
                  </p>
                  <p class="text">
                    今の自分を客観的に知ることも
                    <br>
                    マインドフルネスへの第一歩！
                    <br>
                    12問のカンタンな質問に回答すると、
                    <br>
                    今のあなたのストレス値がわかります。
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    次へ
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_3.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 4 -->
          <div v-show="currentSlide === 3" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  あなたの課題に合わせた
                  <br>
                  コンテンツをお届け
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    習慣化プログラム
                  </p>
                  <p class="text">
                    週に1回のコンテンツを10週間に渡りお届け。
                    <br>
                    体系立ててマインドフルネスの理解を深めることで
                    <br>
                    より実践での効果を実感しやすくなります。
                  </p>
                  <p class="heading">
                    課題別コンテンツ
                  </p>
                  <p class="text">
                    登録時に選択していただいた課題に合わせて、
                    <br>
                    パーソナライズされた学習コンテンツをお届け。
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    次へ
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_4.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 5 Normal User-->
          <div v-show="currentSlide === 4 && !isCompanyUser" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  ポイントを貯めて
                  <br>
                  割引やオリジナルグッズをGET
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    初回の10ポイントで1100円オフに
                  </p>
                  <p class="text">
                    レッスン内で表示されるQRコードを読み込むと
                    <br>
                    ポイントが貯められます(上限1日1ポイント)。
                    <br>
                    貯まったポイントは月額の割引に使えるほか、
                    <br>
                    ノートやTシャツなどのオリジナルグッズと
                    <br>
                    交換できます。
                  </p>
                  <a class="link" href="https://www.the-melon.com/stamp_card/" target="_blank">特典の詳細はこちら></a>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    まずは１分で心を整える
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_5.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 5 Company User -->
          <div v-show="currentSlide === 4 && isCompanyUser" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  ポイントを貯めて
                  <br>
                  Amazonギフト券をGET
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    初回の10ポイントから交換可能！
                  </p>
                  <p class="text">
                    レッスン内で表示されるQRコードを読み込むと
                    <br>
                    ポイントが貯められます(上限1日1ポイント)。
                    <br>
                    貯まったポイントに応じてAmazonギフト券と
                    <br>
                    交換できます。
                  </p>
                  <a class="link" href="https://www.the-melon.com/company-stamp_card/" target="_blank">特典の詳細はこちら></a>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    まずは１分で心を整える
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_5.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 6 -->
          <div v-show="currentSlide === 5" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  動画を再生して
                  <br>
                  1分間瞑想にトライしよう！
                </h2>
              </div>
              <div class="slide-body">
                <div class="content content-6">
                  <p class="heading">
                    まずは1分間の瞑想体験。
                  </p>
                  <p class="text">
                    スマホ画面をクリックして動画を再生。
                    <br>
                    1分間の瞑想にチャレンジしてみましょう！
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    今日のポイントをGET！
                  </button>
                </div>
                <div class="video-wrapper">
                  <div class="video-frame">
                    <div class="notch" />
                    <div class="screen">
                      <div class="video-container" @click="toggleVideo">
                        <video
                          ref="videoPlayer"
                          class="video-player"
                          :src="videoUrl"
                          playsinline
                          @timeupdate="onTimeUpdate"
                          @loadedmetadata="onLoadedMetadata"
                        />
                        <div v-if="!isPlaying" class="play-icon" @click.stop="playVideo">
                          <div class="play-icon-inner" />
                        </div>
                      </div>
                      <div class="controls" @click.stop>
                        <input
                          v-model="currentTime"
                          type="range"
                          min="0"
                          :max="duration"
                          class="seek-bar"
                          @input="seek"
                          @mousedown="isSeeking = true"
                          @mouseup="isSeeking = false"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 7 Normal User-->
          <div v-show="currentSlide === 6" class="slide">
            <div class="slide-content">
              <div class="slide-header">
                <h2 class="header-title">
                  おめでとうございます！
                  <br>
                  初瞑想ポイントGET！
                </h2>
              </div>
              <div class="slide-body">
                <div class="content">
                  <p class="heading">
                    QRコードを読み込んで
                    <br>
                    今日のポイントを獲得しよう！
                  </p>
                  <p class="text">
                    LINEでポイントを貯める仕組みのため、QR
                    <br>
                    コードを読み込むとLINEに遷移します。「友だ
                    <br>
                    ち追加」をしてポイントを獲得しよう！
                  </p>
                  <p class="text-link">
                    <a href="https://liff.line.me/1654883656-XqwKRkd4?aid=676ljwcm&cid=194E1C3E4E52CECF21FD6EC0DAD5A5EC" target="_blank">こちらのリンク</a>
                    からも
                    <br>
                    ポイントを獲得できます。
                  </p>
                  <button class="next-button _dsp-none--sp" @click="nextSlide">
                    マイページへ
                  </button>
                </div>
                <div class="illustration">
                  <img src="/assets/img/tutorial_7.png" alt="">
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation dots -->
          <div class="dots">
            <span
              v-for="n in 7"
              :key="n"
              :class="['dot', { active: currentSlide === n - 1 }]"
              @click="currentSlide = n - 1"
            />
          </div>

          <!-- Next button -->
          <button class="next-button _dsp-none--pc" @click="nextSlide">
            {{ nextButtonText }}
          </button>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'

export default {
  name: 'ModalTutorial',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSlide: 0,
      videoUrl: '/assets/videos/tutorial_01.mp4',
      isPlaying: false,
      isSeeking: false,
      duration: 0,
      currentTime: 0,
      nextButtonText: '次へ'
    }
  },
  computed: {
    isCompanyUser() {
      const userCategory = this.$store.state.user.userInfo.ccategory
      return [5, 6].includes(userCategory)
    }
  },
  watch: {
    isSeeking(newValue) {
      if (!newValue) {
        this.$refs.videoPlayer.currentTime = this.currentTime
      }
    },
    currentSlide(newValue) {
      if (this.isPlaying) {
        this.pauseVideo()
      }
      switch (newValue) {
        case 4:
          this.nextButtonText = 'まずは１分で心を整える'
          break
        case 5:
          this.nextButtonText = '今日のポイントをGET！'
          break
        case 6:
          this.nextButtonText = 'マイページへ'
          break
        default:
          this.nextButtonText = '次へ'
          break
      }
    }
  },
  mounted() {
    const videoPlayer = this.$refs.videoPlayer

    videoPlayer.addEventListener('play', () => {
      this.isPlaying = true
    })

    videoPlayer.addEventListener('pause', () => {
      this.isPlaying = false
    })
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < 6) {
        this.currentSlide++
      } else {
        this.closeModal()
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      }
    },
    closeModal() {
      this.$emit('close')
      if (this.currentSlide < 6) {
        this.$router.push('/')
      } else {
        this.$emit('startTour')
      }
    },
    toggleVideo() {
      if (this.isPlaying) {
        this.pauseVideo()
      } else {
        this.playVideo()
      }
    },
    playVideo() {
      this.$refs.videoPlayer.play()
      this.isPlaying = true
    },
    pauseVideo() {
      this.$refs.videoPlayer.pause()
      this.isPlaying = false
    },
    onTimeUpdate() {
      if (!this.isSeeking) {
        this.currentTime = this.$refs.videoPlayer.currentTime
      }
    },
    onLoadedMetadata() {
      this.duration = this.$refs.videoPlayer.duration
    },
    seek(event) {
      this.currentTime = event.target.value
      this.$refs.videoPlayer.currentTime = this.currentTime
    }
  }
}
</script>
<style>
@font-face {
  font-family: "Hiragino Kaku Gothic Pro";
  src: url(~@/assets/fonts/HiraKakuProN-W6.woff2);
}
</style>
<style scoped src="@/assets/css/modal_tutorial.css">
</style>
